if (!customElements.get('endorsements-cards')) {
  customElements.define(
    'endorsements-cards',
    class EndorsementsCards extends HTMLElement {
      connectedCallback() {
        this.cardElements = Array.from(this.querySelectorAll('[data-endorsements-card]'));

        this.handleClick = this.handleClick.bind(this);
        this.updateCards = this.updateCards.bind(this);

        this.addEventListener('click', this.handleClick);

        this.resizeObserver = new ResizeObserver(this.updateCards);
        this.cardElements.forEach((cardElement) => {
          const descriptionElement = cardElement.querySelector('[data-endorsements-description]');

          if (descriptionElement) this.resizeObserver.observe(descriptionElement);
        });

        this.updateCards();

        document.fonts?.ready.then(() => {
          if (this.isConnected) this.updateCards();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.resizeObserver?.disconnect();
      }

      handleClick(event) {
        const toggleElement = event.target.closest('[data-endorsements-toggle]');

        if (!toggleElement || !this.contains(toggleElement)) return;

        const cardElement = toggleElement.closest('[data-endorsements-card]');

        cardElement.classList.toggle('endorsements__card--expanded');
        this.updateCard(cardElement);
      }

      updateCards() {
        this.cardElements.forEach((cardElement) => this.updateCard(cardElement));
      }

      updateCard(cardElement) {
        const descriptionElement = cardElement.querySelector('[data-endorsements-description]');
        const toggleElement = cardElement.querySelector('[data-endorsements-toggle]');

        if (!descriptionElement || !toggleElement) return;

        const lineHeight = Number.parseFloat(getComputedStyle(descriptionElement).lineHeight);
        const hasOverflow = descriptionElement.scrollHeight > lineHeight * 4 + 1;

        if (!hasOverflow) cardElement.classList.remove('endorsements__card--expanded');

        const isExpanded = hasOverflow && cardElement.classList.contains('endorsements__card--expanded');
        const showMoreElement = toggleElement.querySelector('[data-endorsements-show-more]');
        const showLessElement = toggleElement.querySelector('[data-endorsements-show-less]');

        toggleElement.hidden = !hasOverflow;
        toggleElement.setAttribute('aria-expanded', String(isExpanded));
        showMoreElement.hidden = isExpanded;
        showLessElement.hidden = !isExpanded;
        cardElement.classList.toggle('endorsements__card--overflowing', hasOverflow && !isExpanded);
      }
    }
  );
}
